/**
 * Vruchtvlees © 2007-2019
 *
 * Hi, welcome!
 *
 * This is the main Javscript file.
 * One script to rule them all!
 * Let's go and godspeed you!
 */

import $ from 'jquery';
import { Cookie } from './helpers/Cookie';
/** ----------------------------------------
    Webpack Settings
 ---------------------------------------- */

let webpack = SETTINGS;

/** ----------------------------------------
    Environment
 ---------------------------------------- */

/**
 * This class will check the current
 * environment of the website and stores
 * an object with information about the
 * current environment.
 */

import { Environment } from '@helper/Environment.js';
import { Log } from '@helper/Log.js';

const host = new Environment({
    preview: 'https://fvcp.preview.vruchtvlees.com',
    webpack: webpack
});

const log = new Log(host);

if(!host.info.environment.live) {
    log.section('VV', 'Environment');
    host.log();
}

/** ----------------------------------------
    Set Style Guide
 ---------------------------------------- */

/**
 * This section will set the VV Style Guide
 * as a default for at the index.html.
 *
 * You can mess around with the information
 * it will be displayed within the page.
 */

let info = {
    title: 'Vruchtvlees Digital Style Guide',
    intro: 'This style guide provides guidelines for the digital design as configured within the SASS stylesheets. It will automatically extend and change once you start working on the project. If certain elements or blocks should be left out these can be configured within the config.js file related to the style guide. It serves as a guide to quickly check what variables have been configured, what names they use and how the styling of a certain element has been affected within the stylesheet. Godspeed you!',
};

let config = {
    breakpoints: true,
    typo: true,
    letters: true,
    colors: true,
    headings: true,
    text: true,
    content: true,
    font: true,
    links: true,
    tooltip: true,
    forms: true,
    lists: true,
    tables: true,
    buttons: true,
    icons: true
};

if(!host.info.environment.live) {
    log.title('Style');
}

/** ----------------------------------------
    Mobile class
 ---------------------------------------- */

if (host.info.isMobile)
    document.body.classList.add('is-mobile');

/** ----------------------------------------
    Notification
 ---------------------------------------- */

import { Notification } from './module/Notification';

new Notification();

/** ----------------------------------------
    Header Logo Animation
 ---------------------------------------- */

window.addEventListener('scroll', () => {
    const logo = document.getElementById('js-logo');
    const scroll = window.pageYOffset || document.documentElement.scrollTop;

    if(logo.classList.contains('js-lock'))
        return;

    scroll > 150 ? logo.classList.add('js-rotate') : logo.classList.remove('js-rotate');
});

/** ----------------------------------------
    Slider
 ---------------------------------------- */

import { Sliders } from './module/Sliders';

new Sliders();

import { SlidersPaging } from './module/SlidersPaging';
document.querySelectorAll('[data-js-slider-paging]').forEach(pager => {
    new SlidersPaging(pager, document.querySelectorAll(pager.dataset.jsSliderPaging));
});

import { Draggable } from './module/Draggable';
document.querySelectorAll('[data-js-draggable]').forEach(elem => {
    new Draggable(elem);
});


/** ----------------------------------------
    Header Slider
 ---------------------------------------- */

window.addEventListener('load', () => {
    $('.header-slider__slides').slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
        appendDots: $('.header-slider__dots'),
        prevArrow: false,
        nextArrow: false
    });
});

/** ----------------------------------------
    Gallery Block
 ---------------------------------------- */

$(document).ready(() => {
    $('.gallery-block__slides').each(function() {
        const $leftArrow = $(this)
            .parent()
            .find('.gallery-block__arrows')
            .find('.slider__arrows--left');

        const $rightArrow = $(this)
            .parent()
            .find('.gallery-block__arrows')
            .find('.slider__arrows--right');

        $(this).slick({
            autoplay: true,
            autoplaySpeed: 7500,
            pauseOnHover: false,
            centerMode: true,
            slidesToShow: 1,
            arrows: true,
            prevArrow: $leftArrow,
            nextArrow: $rightArrow,
            dots: false,
            speed: 750,
            centerPadding: '0',
            cssEase: 'cubic-bezier(0.77, 0, 0.175, 1)',
            infinite: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        centerMode: false,
                        cssEase: 'ease',
                    }
                }
            ]
        });
    });
});

/** ----------------------------------------
    Accordion
 ---------------------------------------- */

const accordionClick = (eventHappened) => {
    let targetClicked = event.target;
    let classClicked = targetClicked.classList;

    while (classClicked[0] !='accordion__button'){
        targetClicked = targetClicked.parentElement;
        classClicked = targetClicked.classList;
    }

    let description = targetClicked.nextElementSibling;
    let expander = targetClicked.children[0];

    if (description.style.maxHeight){
        description.style.maxHeight = null;
    } else {
        let allDescriptions = document.querySelectorAll('.accordion__collapse');

        for (var i = 0; i < allDescriptions.length; i++){
            if (allDescriptions[i].style.maxHeight){
                allDescriptions[i].style.maxHeight = null;
            }
        }

        description.style.maxHeight = description.scrollHeight + 'px';
    }
};

window.addEventListener('load', () => {
    const accordion = document.querySelectorAll('.accordion__button');

    for (let i = 0; i<accordion.length; i++){
        accordion[i].addEventListener('click', function(){
            accordionClick(event);
        });
    }
});

/** ----------------------------------------
    Video
 ---------------------------------------- */

import { Video } from './module/video';

const videos = document.querySelectorAll('.video');

for (let video of videos) {
    new Video(video);
}

/** ----------------------------------------
    Fund Tool
 ---------------------------------------- */

import { FundTool } from './module/FundTool';

const fundToolEl = document.querySelector('#fund-tool');

if (fundToolEl) new FundTool(fundToolEl);

/** ----------------------------------------
    Map Filter
 ---------------------------------------- */

import { MapFilter } from './module/MapFilter';

new MapFilter([
    {
        name: 'Friesland',
        id: 'friesland',
        short: 'FR',
        value: 1,
        x: 55,
        y: 10
    },
    {
        name: 'Groningen',
        id: 'groningen',
        short: 'GR',
        value: 2,
        x: 75,
        y: 5
    },
    {
        name: 'Drenthe',
        id: 'drenthe',
        short: 'DR',
        value: 3,
        x: 70,
        y: 22.5
    },
    {
        name: 'Overijssel',
        id: 'overijssel',
        short: 'OV',
        value: 4,
        x: 75,
        y: 37.5
    },
    {
        name: 'Flevoland',
        id: 'flevoland',
        short: 'FL',
        value: 5,
        x: 52.5,
        y: 32.5
    },
    {
        name: 'Gelderland',
        id: 'gelderland',
        short: 'GD',
        value: 6,
        x: 62.5,
        y: 45
    },
    {
        name: 'Utrecht',
        id: 'utrecht',
        short: 'UT',
        value: 7,
        x: 45,
        y: 47.5
    },
    {
        name: 'Noord-Holland',
        id: 'noord-holland',
        short: 'NH',
        value: 8,
        x: 35,
        y: 27.5
    },
    {
        name: 'Zuid-Holland',
        id: 'zuid-holland',
        short: 'ZH',
        value: 9,
        x: 27.5,
        y: 50
    },
    {
        name: 'Noord-Brabant',
        id: 'noord-brabant',
        short: 'NB',
        value: 10,
        x: 47.5,
        y: 70
    },
    {
        name: 'Limburg',
        id: 'limburg',
        short: 'LB',
        value: 11,
        x: 65,
        y: 80
    },
    {
        name: 'Zeeland',
        id: 'zeeland',
        short: 'ZL',
        value: 12,
        x: 12.5,
        y: 70
    },
    {
        name: 'Caribisch deel van het Koninkrijk',
        id: 'caribisch',
        short: 'CDK',
        value: 13,
        x: 15,
        y: 0
    },
]);

/** ----------------------------------------
    Steps Container
 ---------------------------------------- */

import anime from 'animejs';

window.addEventListener('load', () => {
    const step = document.body.querySelector('#js-steps');
    if(!step) return;

    const steps = step.querySelectorAll('.step');

    [...steps].map(step => {
        const title = step.querySelector('.step__title');

        title.addEventListener('click', () => {
            const hidden = step.querySelector('.step__hidden');
            const content = step.querySelector('.step__content');
            const height = content.offsetHeight;

            if(step.classList.contains('js-active')) {
                anime({
                    targets: hidden,
                    height: 0,
                    duration: 500,
                    easing: 'easeOutCirc'
                });

                step.classList.remove('js-active');
            } else {
                anime({
                    targets: hidden,
                    height: height + 30,
                    duration: 1250,
                    completed: () => {
                        hidden.style.height = 'auto';
                    }
                });

                step.classList.add('js-active');
            }
        });
    });
});

/** ----------------------------------------
    Dropdown
 ---------------------------------------- */

import { Dropdown } from './module/Dropdown';

const filters = document.querySelectorAll('.dropdown__options');

for (let filter of filters) {
    if(filter) new Dropdown({
        holder: filter,
        trigger: '.dropdown__selected',
        target: '.dropdown__holder',
        options: '.dropdown__form'
    }, host);
}

/** ----------------------------------------
    Content Filter
 ---------------------------------------- */

// import { FundFilter } from './module/FundFilter';
import { ProjectFilter } from './module/ProjectFilter';
import { LoadMore } from './module/LoadMore';
import { MagazineFilter } from './module/MagazineFilter';

// new FundFilter();
new ProjectFilter();
new MagazineFilter();
new LoadMore();

/** ----------------------------------------
    Social Share
 ---------------------------------------- */

import SocialShare from './module/SocialShare';

const share = document.querySelectorAll('[data-module="social"]');
[...share].map(el => el && new SocialShare(el));

/** ----------------------------------------
    Advice
 ---------------------------------------- */

window.addEventListener('load', () => {
    const advice = document.body.querySelector('#js-advice');

    if(!advice)
        return;

    const adviceButton = advice.querySelector('.advice__button');
    const adviceClose = advice.querySelector('.advice__close');
    const adviceTip = advice.querySelector('.advice__tip');

    adviceButton.addEventListener('click', () => {
        if (adviceTip.classList.contains('active')) {
            adviceTip.classList.remove('active');
        } else {
            adviceTip.classList.add('active');
        }
    });

    adviceClose.addEventListener('click', () => {
        if (adviceTip.classList.contains('active')) {
            adviceTip.classList.remove('active');
        }
    });
});

/** ----------------------------------------
    English popup
 ---------------------------------------- */

if (document.children[0].lang === 'en') {
    let enUrls = JSON.parse(document.querySelector('#js-en-urls').dataset.urls);
    enUrls.shift();

    Array.from(document.querySelectorAll('a')).forEach(el => {
        if (
            el.href.startsWith(`${window.location.protocol}//${window.location.host}`) &&
            !el.href.startsWith(`${window.location.protocol}//${window.location.host}/#`) &&
            enUrls.findIndex((item) => el.href.startsWith(item)) < 0
        ) {
            el.addEventListener('click', ev => {
                ev.preventDefault();
                const popup = document.body.querySelector('[data-js-popup-id="english"]');
                const nav = document.querySelector('nav');
                nav.classList.toggle('is-disabled', true);
                popup.classList.toggle('is-active', true);

                popup.querySelectorAll('[data-js-popup="close"]').forEach(btn => {
                    if(btn.classList.contains('popup__close')) {
                        return;
                    }

                    btn.addEventListener('click', () => {
                        document.location.href = el.href;
                    });
                });
            });
        }
    });
}

/** ----------------------------------------
    Popup
 ---------------------------------------- */

window.addEventListener('load', () => {
    const wrapper = document.querySelector('.popup-wrapper');
    const popupOpenBtns = document.querySelectorAll('[data-js-popup*="open"]');
    const popupCloseBtns = document.querySelectorAll('[data-js-popup="close"]');
    const nav = document.querySelector('nav');

    if(!wrapper) return;

    // Toggles popup
    function togglePopup(state, popup) {
        nav.classList.toggle('is-disabled', state);
        popup.classList.toggle('is-active', state);
    }

    // Open button click handling
    popupOpenBtns.forEach(btn => {
        btn.addEventListener('click', function() {
            const selector = this.dataset.jsPopup.replace(/open\(\'(.*)\'\)/gi, '$1');
            const popup = document.querySelector(selector);
            togglePopup(true, popup);
            document.body.classList.add('no-scroll');
        });
    });

    // Close button click handling
    popupCloseBtns.forEach(btn => {
        btn.addEventListener('click', (event) => {
            const popup = document.querySelector('.popup-wrapper.is-active');
            togglePopup(false, popup);
            document.body.classList.remove('no-scroll');

            const parent  = event.target.parentElement;
            const subsidyTitle = parent.querySelector('.popup__title--subsidies');
            subsidyTitle.remove();
        });
    });
});

/** ----------------------------------------
    Team Popup
 ---------------------------------------- */

window.addEventListener('load', () => {
    const members = document.body.querySelectorAll('.js-member');

    [...members].map(member => member.addEventListener('click', fillPopup));

    function fillPopup(event) {
        const el = {};
        const popup = document.body.querySelector('.js-popup-member');
        const member = event.currentTarget;
        const data = JSON.parse(member.dataset.content);
        const funds = JSON.parse(member.dataset.funds);
        const types = JSON.parse(member.dataset.types);
        const image = member.dataset.image;

        [
            'image',
            'name',
            'role',
            'phone',
            'email',
            'description'
        ].map(field => {

            el[field] = popup.querySelector(`.popup__${ field }`);

            if(field !== 'image' && field !== 'email' && field !== 'phone')
                el[field].innerHTML = data[field];

            if(field === 'image')
                el[field].src = image;

            if(field === 'email' || field === 'phone') {
                const span = el[field].querySelector('span');
                span.innerHTML = data[field];

                if (data[field] === ''){
                    el[field].style.display = 'none';
                } else {
                    el[field].style.display = '';
                }
            }
        });

        const typesList = popup.querySelector('#js-member-types');
        const fundsList = popup.querySelector('#js-member-funds');
        const title = popup.querySelector('.popup__title--subsidies');

        typesList.innerHTML = '';
        fundsList.innerHTML = '';

        Object.keys(types).map((key, index) => {
            const html = `<span class="tag tag-solid--pink">${ key }</span>`;
            typesList.insertAdjacentHTML('afterbegin', html);
        });

        if (funds.length && funds.some(fund => fund.publication_state !== 'DRAFT') && !title) {
            const title = '<h6 class="popup__title popup__title--subsidies popup__title--small">Gekoppelde subsidies</h6>';
            fundsList.insertAdjacentHTML('beforebegin', title);
        }

        if (title && !funds.length) {
            title.style.display = 'none';
        } else if(title) {
            title.style.display = '';
        }

        funds.map(fund => {
            const html = `<a class="popup__item" href="${ fund.url }">${ fund.title }</a>`;
            fund.publication_state === 'LIVE' && fundsList.insertAdjacentHTML('afterbegin', html);
        });
    }
});

/** ----------------------------------------
    Tooltip
 ---------------------------------------- */

window.addEventListener('load', () => {
    const tooltips = document.querySelectorAll('.fund-overview__tooltip');

    [...tooltips].map(tooltip => {
        if(!tooltip.dataset.id)
            return;

        tooltip.addEventListener('click', (e) => {
            const popupWrapper = document.querySelector(`#js-popup-${ tooltip.dataset.id }`);
            !popupWrapper.classList.contains('is-active') ? popupWrapper.classList.add('is-active') : popupWrapper.classList.remove('is-active');
        });
    });
});

/** ----------------------------------------
    Enlarge Image
 ---------------------------------------- */

import { EnlargeImage } from './module/EnlargeImage';

const images = document.querySelectorAll('.js-enlarge');

for (let image of images) {
    if(image) new EnlargeImage(image);
}

/** ----------------------------------------
    Forms
 ---------------------------------------- */

import { Form } from './module/Form';

const forms = document.querySelectorAll('.js-form');

[...forms].forEach(form => {
    new Form(form);
});

/** ----------------------------------------
    Sticky side
 ---------------------------------------- */

import { StickySide } from './module/StickySide';

const stickySide = document.querySelector('.side--sticky');

new StickySide(stickySide);

/** ----------------------------------------
    Easter Egg
 ---------------------------------------- */

/**
 * Easter comes early this year, enjoy!
 */

import { Confetti } from './style/easter/Confetti';
new Confetti();

// /** ----------------------------------------
//     Recaptcha Form
//  ---------------------------------------- */

// import { RecaptchaForm } from './module/RecaptchaForm';

// for (const form of document.querySelectorAll('.js-form')) {
//     const recaptchaForm = new RecaptchaForm({
//         form: form,
//         action: 'form',
//     });

//     recaptchaForm.init();

//     recaptchaForm.success = (data) => {
//         console.log(data);
//     };
// }

/** ----------------------------------------
 Accordion
 ---------------------------------------- */

$(document).ready(function(){
    $('.js-accordion').each(function() {
        $(this).find('.js-accordion__answer').hide();
        $(this).find('.js-accordion__question').each(function() {
            let question = $(this);
            let answer = $(this).parent().find('.js-accordion__answer');
            $(this).on('click', function() {
                answer.slideToggle('fast');
                if (question.hasClass('is-active')) {
                    question.removeClass('is-active');
                    answer.removeClass('is-active');
                } else {
                    question.addClass('is-active');
                    answer.addClass('is-active');
                }
            });

        });
    });
});

/** ----------------------------------------
    Mobile Navigation
 ---------------------------------------- */

import { PriorityPlusMenu } from './module/PriorityPlus';
$(document).ready(function handleNav() {
    new PriorityPlusMenu({
        toggle: document.querySelector('.nav__toggle-button'),
        navItems: document.querySelectorAll('.nav__menu [data-priority]'),
    });
});
